import { useLocation, useParams } from 'react-router-dom';
import { MainArea, Page, Gap } from '@salecycle/ui-component-library';
import { UploadSuccess } from '../components/UploadSuccess';
import { ImportConsentProvider } from '../context/ImportConsentContext';
import { ClientLevel } from 'core/types';
import { useTranslation } from 'react-i18next';

export const ConsentUploadSuccessPage = () => {
  const { t } = useTranslation('fileManagement');
  const { clientLevel, clientId } = useParams<{ clientLevel: ClientLevel; clientId: string }>();
  const { state } = useLocation<{ successUploadCount: number }>();

  return (
    <ImportConsentProvider clientLevel={clientLevel} clientId={clientId} successUploadCount={state?.successUploadCount}>
      <MainArea>
        <Page heading={t('upload.heading')} padding={0}>
          <Gap top={22} />
          <UploadSuccess />
        </Page>
      </MainArea>
    </ImportConsentProvider>
  );
};
